module.exports = __webpack_public_path__ + "static/media/congrats_icon.bf2186d4.svg";